import * as React from 'react';
import { connect } from 'react-redux';
import './OutdatedBrowserWarning.scss';
import { bindActionCreators } from 'redux';
import { updateOutdatedState as updateOutdatedStateAction } from 'login-actions/globalActions';
import AppHeader from '../AppHeader/AppHeader';

interface DispatchProps {
  updateOutdatedState: (boolean) => any;
}

class OutdatedBrowserWarning extends React.Component<DispatchProps, {}> {
  setWarningToFalse = () => {
    const { updateOutdatedState } = this.props;
    updateOutdatedState(false);
  };

  render() {
    return (
      <div className="OutdatedBrowserWarning">
        <AppHeader text="You're using a browser we don't support." />
        <p className="OutdatedBrowserWarning-detailText">
          Our app works best on a modern browser. For the best experience, please upgrade to one of the below browsers.
        </p>
        <ul className="OutdatedBrowserWarning-unsupportedBrowserList">
          <li>
            <a href="https://www.google.com/chrome/browser" target="_blank">
              Get Google Chrome
            </a>
          </li>
          <li>
            <a href="https://www.mozilla.org/en-US/firefox/" target="_blank">
              Get Mozilla Firefox
            </a>
          </li>
        </ul>
        <p className="js-OutdatedBrowserWarning-skip OutdatedBrowserWarning-skip">
          <a href="#" onClick={this.setWarningToFalse}>
            Continue Anyway
          </a>
        </p>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ updateOutdatedState: updateOutdatedStateAction }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(OutdatedBrowserWarning);
